var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RequestClient } from "../basics/request-client.service";
import { autoinject } from "aurelia-framework";
import { Api } from "../../constants/modules/api.constants";
import { toNative } from "../../utilities/promise-utils";
var WinSimulationClientService = /** @class */ (function () {
    function WinSimulationClientService(requestClient) {
        this.requestClient = requestClient;
    }
    WinSimulationClientService.prototype.getInfo = function (lotteryId) {
        return toNative(this.requestClient.get("".concat(Api.WinSimulation.GetInfo, "/").concat(lotteryId), {}));
    };
    WinSimulationClientService.prototype.set = function (request) {
        return toNative(this.requestClient.post(Api.WinSimulation.Set, {}, request));
    };
    WinSimulationClientService.prototype.toggle = function (lotteryId, isActive) {
        return toNative(this.requestClient.post("".concat(Api.WinSimulation.Toggle, "/").concat(lotteryId), { isActive: isActive }, null));
    };
    WinSimulationClientService.prototype.deleteSimulation = function (lotteryId) {
        return toNative(this.requestClient.post("".concat(Api.WinSimulation.Delete, "/").concat(lotteryId), {}, null));
    };
    WinSimulationClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient])
    ], WinSimulationClientService);
    return WinSimulationClientService;
}());
export { WinSimulationClientService };
